import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import packageInfo from '../../../package.json'

import style from './Configuration.module.css'

export type ConfigurationProps = {}

export function Configuration(props: ConfigurationProps): JSX.Element {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      flexBasis="100%"
    >
      <Box
        className={style.configurationList}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {/* 
        {loggedUserService.userCan(Permission.configureNotifications) && (
          <ConfigurationItemLink
            imgSrc={notifications}
            label={t('notificationsConfig')}
            route={ROUTE_NOTIFICATIONS_CONFIG}
            addSeparator={true}
          />
        )}
        {loggedUserService.userCan(Permission.configureSymptoms) && (
          <ConfigurationItemLink
            imgSrc={iconSymptom}
            label={t('symptomsConfig')}
            route={ROUTE_SYMPTOMS_CONFIG}
            addSeparator={true}
          />
        )}
        {loggedUserService.userCan(Permission.configurePatientCalendar) && (
          <ConfigurationItemLink
            imgSrc={calendar}
            label={t('patientCalendarConfig')}
            route={ROUTE_PATIENT_CALENDAR_CONFIG}
            addSeparator={true}
          />
        )}
        {loggedUserService.userCan(Permission.configureDentists) && (
          <ConfigurationItemLink
            imgSrc={patientData}
            label={t('dentistConfig')}
            route={ROUTE_DENTIST_CONFIG}
            addSeparator={true}
          />
        )} */}
        <h3 className={style.version}>Version {packageInfo.version}</h3>
      </Box>
    </Box>
  )
}
